let ringtoneAudio = null;

export const playRingtone = () => {
  if (!ringtoneAudio) {
    ringtoneAudio = new Audio('/sounds/ringtone.mp3');
    ringtoneAudio.loop = true;
  }
  ringtoneAudio.play().catch((err) => {
    console.error('Failed to play ringtone', err);
  });
};

export const stopRingtone = () => {
  if (ringtoneAudio) {
    ringtoneAudio.pause();
    ringtoneAudio.currentTime = 0;
  }
};

export const requestMicrophonePermission = async () => {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true });
    return true;
  } catch (error) {
    return false;
  }
};
